<template>
  <div id="app">
    <header>
      <div class="top-menu">
        <div class="top-left">
          <ul>
            <li>{{ time }}</li>
            <li>
              <a href="#">Đấu trường chứng khoán</a>
            </li>
            <li>
              <a href="#">Diễn đàn</a>
            </li>
            <li>
              <a href="#">Đào tạo</a>
            </li>
            <li>
              <a href="#">Dịch vụ Vietstock</a>
            </li>
          </ul>
        </div>
        <div class="top-right">
          <ul>
            <li>
              <a href="#">Đăng nhập</a>
            </li>
            <li>
              <a href="#">English</a>
            </li>
          </ul>
        </div>
      </div>
      <div class="row no-gutters">
        <div class="col logo">
          <img src="@/assets/theme/vindex.png">
        </div>
        <div class="col">

        </div>
      </div>
    </header>
    <div class="main-menu">
      <ul>
        <li>Vĩ mô</li>
        <li>Thị trường</li>
        <li>Ngành</li>
        <li>Doanh nghiệp</li>
        <li>Phái sinh</li>
        <li>Công cụ đầu tư</li>
        <li>Truy xuất Dữ liệu</li>
        <li>TIN TỨC</li>
      </ul>
    </div>
    <div class="the-content">
      <div class="main-content">
        <router-view/>
      </div>
      <div class="the-sidebar">
        <Sidebar />
      </div>
      <div class="clearfix"></div>
    </div>
    <Banners class="mb-3" />
    <!-- <ListCompany /> -->
    <Footer />
  </div>
</template>
<script>
import Footer from './views/components/Footer'
import Banners from './views/components/Banners'
import Sidebar from './views/components/Sidebar'
import moment from '@/moment'

export default {
  components: {
    // LastPriceIndex,
    Footer,
    // ListCompany,
    Banners,
    Sidebar
  },
  data() {
    return {
      time: moment().format("dddd, DD/MM/YYYY hh:mm:ss A")
    }
  },
  created() {
    this.interval = setInterval(()=>{
      this.time = moment().format("dddd, DD/MM/YYYY hh:mm:ss A")
    }, 1000)
  }
}
</script>
<style lang="scss">
  /* Import Font Awesome 5 Icons Set */
  $fa-font-path: '~@fortawesome/fontawesome-free/webfonts';
  @import '~@fortawesome/fontawesome-free/scss/fontawesome.scss';
  @import '~@fortawesome/fontawesome-free/scss/solid.scss';
  @import '~@fortawesome/fontawesome-free/scss/regular.scss';
  @import '~@fortawesome/fontawesome-free/scss/brands.scss';

body {
  margin: 0;
  padding: 0;
}

#app {
  width: 900px;
  margin: 0 auto;

  header {
    background-color: #FFFFFF;
    border-bottom: 1px solid #FFFFFF;

    .logo {
      padding: 15px 0px;

      img {
        height: 60px;
      }
    }

    .top-menu {
      border-bottom: 1px solid #ecedee;
      padding: 5px 0px;
      display: flex;
      justify-content: space-between;

      .top-left {
        ul {
          padding: 0;
          margin: 0;
          display: flex;

          li {
            list-style: none;
            font-size: 85%;
            color: #545b66;
            position: relative;
            display: block;
            padding: 0 8px;

            a {
              color: #545b66;
            }
          }

          li:first-child {
            padding-left: 0px;
          }

          li:after {
            position: absolute;
            content: "";
            height: 10px;
            width: 1px;
            background: #222;
            opacity: .3;
            right: 0;
            top: 50%;
            margin-top: -4.5px;
          }

          li:last-child:after {
            padding-right: 0px;
            width: 0px;
          }
        }
      }

      .top-right {
        ul {
          padding: 0;
          margin: 0;
          display: flex;

          li {
            list-style: none;
            font-size: 95%;
            color: #545b66;
            position: relative;
            display: block;
            padding: 0 8px;

            a {
              color: #545b66;
            }
          }

          li:first-child {
            padding-left: 0px;
          }

          li:last-child {
            padding-right: 0px;
          }

          li:after {
            position: absolute;
            content: "";
            height: 10px;
            width: 1px;
            background: #222;
            opacity: .3;
            right: 0;
            top: 50%;
            margin-top: -4.5px;
          }

          li:last-child:after {
            padding-right: 0px;
            width: 0px;
          }
        }
      }
    }
  }

  .main-menu {
    background-color: #01579B;
    border-top-right-radius: 4px;
    border-top-left-radius: 4px;

    ul {
      padding: 4px 0px;
      margin: 0;
      display: flex;
      justify-content: space-around;

      li {
        list-style: none;
        color: #FFFFFF;
        padding: 2px 8px;
        cursor: pointer;
        font-size: 95%;
      }

      li:hover {
        // background-color: #910223;
        color: #4183c4;
      }
    }
  }

  .the-content {
    margin: 15px 0;

    .main-content {
      float: left;
      width: 550px;
    }

    .the-sidebar {
      float: right;
      width: 330px;
    }
  }
}
</style>
